import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, Clock, ArrowRight, X } from "lucide-react";

export function TrialBanner() {
  const [sub, setSub] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/subscription/me").then(({ data }) => setSub(data)).catch(() => {});
  }, []);

  if (!sub || dismissed) return null;
  const status = sub.subscription_status;
  if (status !== "trialing" && status !== "past_due" && status !== "canceled") return null;

  const isTrial = status === "trialing";
  const cfg = isTrial
    ? { icon: Clock, cls: "bg-amber-50 border-amber-200 text-amber-800",
        text: `無料トライアル残り ${sub.trial_days_left ?? "—"} 日。続けてご利用いただくにはプランに登録してください。` }
    : { icon: AlertTriangle, cls: "bg-red-50 border-red-200 text-red-800",
        text: status === "past_due" ? "お支払いが確認できません。サービス停止を避けるためお支払い方法をご確認ください。"
                                    : "サブスクリプションが解約されています。再開するにはプランに登録してください。" };

  return (
    <div className={`flex items-center gap-3 px-4 md:px-6 py-2.5 border-b text-sm ${cfg.cls}`} data-testid="trial-banner">
      <cfg.icon className="w-4 h-4 shrink-0" />
      <span className="flex-1">{cfg.text}</span>
      <Link to="/settings/billing" className="inline-flex items-center gap-1 font-medium hover:underline shrink-0" data-testid="trial-banner-cta">
        プランを見る<ArrowRight className="w-3.5 h-3.5" />
      </Link>
      {isTrial && (
        <button onClick={() => setDismissed(true)} className="shrink-0 opacity-60 hover:opacity-100" data-testid="trial-banner-dismiss">
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
